module.exports = __webpack_public_path__ + "img/img_customer_officeworker.821fc538.svg";